import { render } from "./FoodSlider.vue?vue&type=template&id=f4c485a6"
import script from "./FoodSlider.vue?vue&type=script&lang=js"
export * from "./FoodSlider.vue?vue&type=script&lang=js"

import "./FoodSlider.vue?vue&type=style&index=0&id=f4c485a6&lang=scss"
import "./FoodSlider.vue?vue&type=style&index=1&id=f4c485a6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__